<img *ngIf="loading" src="https://fsi-application.s3.amazonaws.com/latin-spanish/spanish-latin-america-loading.jpg">
<div *ngIf="coursePlayerState$ | async as coursePlayerState">
    <div class="player-overlay" *ngIf="coursePlayerState.ui.content.showingTips">
        <app-player-overlay (click)="click()"></app-player-overlay>
    </div>
    <div class="progress" style="height:20px">        
        <div class="progress-bar" [style.width.%]="coursePlayerState.ui.content.completed" style="height:20px"></div>
    </div>
    <div class="player-background">    
        <div class="player-container">                    
            <div class="tips-overlay">
                <app-close></app-close>
                <app-tips></app-tips>
            </div>
            <div class="buttons-overlay">
                <app-page-left-button 
                    [visible]="coursePlayerState.ui.leftNavButton.visible" 
                    [disabled]="coursePlayerState.ui.leftNavButton.disabled"
                    [prevUnit]="coursePlayerState.ui.leftNavButton.isPrevUnit"
                    [prevUnitId]="coursePlayerState.ui.leftNavButton.prevUnitId"
                    [prevModule]="coursePlayerState.ui.leftNavButton.isPrevModule"
                    [prevModuleId]="coursePlayerState.ui.leftNavButton.prevModuleId"
                    ></app-page-left-button>
                <app-page-right-button 
                    [visible]="coursePlayerState.ui.rightNavButton.visible" 
                    [disabled]="coursePlayerState.ui.rightNavButton.disabled"
                    [nextUnit]="coursePlayerState.ui.rightNavButton.isNextUnit"
                    [nextUnitId]="coursePlayerState.ui.rightNavButton.nextUnitId"
                    [nextModule]="coursePlayerState.ui.rightNavButton.isNextModule"
                    [nextModuleId]="coursePlayerState.ui.rightNavButton.nextModuleId"
                    ></app-page-right-button>                       
            </div>                
            <app-content-section [zoomWidth]="coursePlayerState.ui.content.zoom" [currentUrl]="coursePlayerState.ui.content.pageUrl"></app-content-section>        
            <app-audio-overlay 
                [audioProgress]="coursePlayerState.ui.audioPanel.audioCompleted"
                [visible]="coursePlayerState.ui.audioPanel.visible" 
                [showPlayButton]="coursePlayerState.ui.audioPanel.playPauseButton.visible"
                [skipBackState]="coursePlayerState.ui.audioPanel.leftSkipButton"
                [skipForwardState]="coursePlayerState.ui.audioPanel.rightSkipButton"
                [playPauseButtonState]="coursePlayerState.ui.audioPanel.playPauseButton"
                >
            </app-audio-overlay>                    
        </div>
    </div>
</div>